import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchDispensedProductAutocomplete({ inputValue, medicationId }) {
    return useQuery(
        ['dispensedProductAutocomplete', inputValue, medicationId],
        () => {
            if (!inputValue || inputValue.length < 2) return null;
            return PESService.searchMedispanData('inputString', inputValue, { medicationId });
        },
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchDispensedProductAutocomplete;
